// Area Navigation component

// This file was once generated when you created this area
// but you can edit it freely

import {
  type AreaNavigationProps,
  NavigationItem,
} from '@backoffice-frontend/patterns'
import { EyeIcon } from '@moia-dev/pace-icons'
import { EvaluationAiAreaRoutes } from './EvaluationAiAreaRoutes'

// TODO: add your NavigationItem to the main menu
// check docs/guides/libraries.md for more info

// TODO: Replace icon with your actual area icon
export const EvaluationAiAreaNavigationIcon = EyeIcon

export const EvaluationAiAreaNavigation = ({
  onClick,
  open,
  label,
}: AreaNavigationProps) => {
  return (
    <NavigationItem
      onClick={onClick}
      open={open}
      label={label}
      to={EvaluationAiAreaRoutes.route}
      Icon={EyeIcon}
    />
  )
}
